export function initLangSwitcher() {
  const switcher = document.querySelector(".lang-switcher");
  if (!switcher) {
    return;
  }

  const slider = switcher.querySelector(".lang-switcher__slider");
  const links = switcher.querySelectorAll(".lang-switcher__link");

  if (!slider || links.length !== 2) {
    return;
  }

  // Check if mobile (matches CSS breakpoint-md: 768px)
  const isMobile = () => window.innerWidth < 768;

  links.forEach((link, index) => {
    link.addEventListener("click", (e) => {
      // Skip if already active
      if (link.classList.contains("lang-switcher__link--active")) {
        return;
      }

      e.preventDefault();
      const href = link.href;

      // Animate slider before navigation using class toggle
      if (index === 1) {
        slider.classList.add("lang-switcher__slider--en");
      } else {
        slider.classList.remove("lang-switcher__slider--en");
      }

      // Update active states
      links.forEach((l) => l.classList.remove("lang-switcher__link--active"));
      link.classList.add("lang-switcher__link--active");

      // Navigate - immediately on mobile, with delay on desktop for animation
      if (isMobile()) {
        window.location.href = href;
      } else {
        setTimeout(() => {
          window.location.href = href;
        }, 250);
      }
    });
  });
}
